import { parseDate } from './get-formatted-date';

export const addDaysToDate = (dateObj: any, days: number): Date => {
  const date = parseDate(dateObj);
  const newDate = new Date(date.getTime() + days * 86400000); // multiply days with milli-secs in a day
  return newDate;
};

export const getDifferenceInDays = (dateOne: any, dateTwo: any) => {
  if (!dateOne || !dateTwo) {
    return NaN;
  }

  const dateOneObj = parseDate(dateTwo);
  const dateTwoObj = parseDate(dateOne);

  const dateDiffInMilliSecs = dateOneObj.getTime() - dateTwoObj.getTime();
  const dateDiffInDays = dateDiffInMilliSecs / 86400000;

  return Math.ceil(dateDiffInDays);
};

export const isJsDateEarlierThanToday = (jsDate: Date): boolean => {
  const timeDifference = new Date().getTime() - jsDate.getTime();
  const dayDifference = Math.floor(timeDifference / 86400000);

  return dayDifference > 0;
};

const secondsPerDay: number = 86400;
const secondsPerYear: number = 31536000;
const plural = (interval: number, singular: string): string => interval === 1 ? singular : `${singular}s`;

export const timeSince = (date: Date): string => {
  let interval: number;
  const seconds: number = Math.floor((new Date().getTime() - date.getTime()) / 1000);

  // Check if number in years range
  interval = Math.floor(seconds / secondsPerYear);
  if (interval >= 1) {
    return `More than ${interval} ${plural(interval, 'year')} ago`;
  }

  // Calculate number of days
  interval = Math.floor(seconds / secondsPerDay);
  if (interval >= 1) {
    return `${interval} ${plural(interval, 'day')} ago`;
  }

  return 'Today';
};
